// extracted by mini-css-extract-plugin
export default {"formContainer":"RegisterPage_formContainer__xv6aI","formRow":"RegisterPage_formRow__6Iz-V","error":"RegisterPage_error__lckr1","loginLink":"RegisterPage_loginLink__OUtNg"};